module.exports = __webpack_public_path__ + "static/media/publicsonar_mobility_hover.46830088.svg";